import { StageService } from '../../../services/stage-modal.service';
import { CoreService, HttpService } from '../../../../../../services';
import { Component, OnInit } from '@angular/core';
import { QResult } from '../../../../../../models';
import { ExtraQuestionnaireStage } from '../../../../../../models/formation/formation.model';
import { ToastService } from '../../../../../../toast'
import { DateRequiredBoProperty } from '../../../../../../models/bodisplay/dynamictags-inline/dynamictags-inline.model';



@Component({
  selector: 'queoval-stage-questionnaires-affectation',
  templateUrl: './affectation.component.html',
  styleUrls: ['./affectation.component.css']
})
/*
* Composant pour l'affichage de la liste des questionnaires
*/
export class AffectationComponent implements OnInit {

  // #region CONSTRUCTEUR
  constructor(
    public service: StageService,
    private http: HttpService,
    private core: CoreService,
    private toast: ToastService,
  ) { }
  // #endregion

  // #region VARIABLES GLOBALES
  /** model qui stock les données du composant*/
  public infosQuestionnaires: ExtraQuestionnaireStage;
  // #endregion

  // #region CYCLE DE VIE

  public ngOnInit(): void {
    this.infosQuestionnaires = new ExtraQuestionnaireStage();
    this.InitData();
  }
  // #endregion

  // #region FONCTIONS PUBLIQUES

  /**
   * met à jour la date d'activation d'un groupe de questionnaire
   * @param date nouvelle date
   * @param groupQuest group de la date (Ex: Ques1PRO)
   */
  public UpdateDate(date: DateRequiredBoProperty,groupQuest:string): void {

    this.infosQuestionnaires.DateToUpdate = new DateRequiredBoProperty();
    this.infosQuestionnaires.GroupDateToUpdate = "";

    this.infosQuestionnaires.DateToUpdate = date;
    this.infosQuestionnaires.GroupDateToUpdate = groupQuest;

    this.infosQuestionnaires.IdentStage = this.service.Stage.Ident;

    this.http.postHttp<QResult<ExtraQuestionnaireStage>>(`${this.core.AppParams.apiUrl}api/Stage/Extranet/Questionnaires/CHANGE_DATE`, this.infosQuestionnaires).subscribe(
      (result: QResult<ExtraQuestionnaireStage>) => {
        if (!result.HasError) {
          this.infosQuestionnaires = result.Value;
          this.toast.showSuccessToast("La date d'activation a été mis à jour");
        }
      });
  }
  /**
  * met à jour la propriete selectionné 
  * @param e event de l'option sélectionnée
  */
  public UpdateProp(e: any) {
    this.infosQuestionnaires.IdentPropToUpdate = "";
    this.infosQuestionnaires.GroupPropToUpdate = "";

    this.infosQuestionnaires.IdentPropToUpdate = e.selectedOptions[0].value;
    this.infosQuestionnaires.GroupPropToUpdate = e.selectedOptions[0].getAttribute('type');
    this.infosQuestionnaires.IdentStage = this.service.Stage.Ident;

    this.http.postHttp<QResult<ExtraQuestionnaireStage>>(`${this.core.AppParams.apiUrl}api/Stage/Extranet/Questionnaires/CHANGE_PROP`, this.infosQuestionnaires).subscribe(
      (result: QResult<ExtraQuestionnaireStage>) => {
        if (!result.HasError) {
          this.infosQuestionnaires = result.Value;
          this.toast.showSuccessToast("Le questionnaire a été mis à jour");
        }
      });
  }

  // #endregion

  // #region FONCTIONS PRIVES
  /**
   * récupére les infos pour chaques questionnaire
   * */
  private InitData() {
    this.core.showSplash(true);
    this.http.getHttp<QResult<ExtraQuestionnaireStage>>(`${this.core.AppParams.apiUrl}api/Stage/Extranet/Questionnaires/INIT_LIST_QUESTIONNAIRES/${this.service.Stage.Ident}`)
      .subscribe((result: QResult<ExtraQuestionnaireStage>) => {
        if (!result.HasError) {
          this.infosQuestionnaires = result.Value;
        }
        this.core.showSplash(false);
      });
  }

  // #endregion
}
